import { format } from 'date-fns'

import '../sass/home-header-online.scss';

(() => {
    const $homeHeaderOnlines = document.querySelectorAll('.home-header-online');

    if (!$homeHeaderOnlines) return;

    $homeHeaderOnlines.forEach($homeHeaderOnline => {
        const $countdowns = $homeHeaderOnline.querySelectorAll('.home-header-online__countdown');
        const $times = $homeHeaderOnline.querySelectorAll('.home-header-online__time');

        const initTimes = () => {
            if (!$times) return;

            $times.forEach($time => {
                const { time, timeFormat } = $time.dataset;

                const dateTime = new Date(time);

                console.log(format(dateTime, timeFormat));

                $time.innerHTML = format(dateTime, timeFormat);
            });
        };

        const initCountdown = () => {
            if (!$countdowns) return;

            $countdowns.forEach($countdown => {
                const $countdownHrs = $countdown.querySelector('.home-header-online__countdown-hrs');
                const $countdownMins = $countdown.querySelector('.home-header-online__countdown-mins');
                const $countdownSecs = $countdown.querySelector('.home-header-online__countdown-secs');

                const biddingClose = new Date(parseInt($countdown.dataset.biddingClose) * 1000);

                setInterval(() => {
                    const now = new Date();

                    const diff = new Date(biddingClose.getTime() - now.getTime());

                    if ($countdownHrs.innerHTML != diff.getUTCHours()) {
                        $countdownHrs.innerHTML = String(diff.getUTCHours()).padStart(2, '0');
                    }

                    if ($countdownMins.innerHTML != diff.getUTCMinutes()) {
                        $countdownMins.innerHTML = String(diff.getUTCMinutes()).padStart(2, '0');
                    }

                    if ($countdownSecs.innerHTML != diff.getUTCSeconds()) {
                        $countdownSecs.innerHTML = String(diff.getUTCSeconds()).padStart(2, '0');
                    }
                }, 1000);
            });
        };

        initTimes();
        initCountdown();
    });
})();
